import React from 'react';
import { inject, observer } from 'mobx-react';

import './style';
import E9Header from './E9Header';
import E9LeftMenu from './E9LeftMenu';

import { WeaLocaleProvider } from 'ecCom';

const getLabel = WeaLocaleProvider.getLabel;

@inject('portalThemeStore')
@observer
class E9Theme extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { location = {}, portalThemeStore } = this.props;
    const { pathname, query } = location;
    portalThemeStore.getTopMenu(pathname, query);
  }

  render() {
    const { portalThemeStore } = this.props;
    const { searchParams = {}, themeInfo = {}, translatepage } = portalThemeStore;
    const { hideHeader, hideAside } = searchParams;
    const { themeColorType } = themeInfo;
    const colorClassName = themeColorType ? `e9theme-color-${themeColorType}` : '';

    let contenttop = '';
    if (hideHeader == 'true') {
      contenttop = translatepage == '1' ? '30px' : '0px';
    } else {
      contenttop = translatepage == '1' ? '85px' : '55px';
    }

    return (
      <div className={`e9theme-layout-container ${colorClassName}`}>
        {translatepage == '1' ? (
          <div className="e9theme-translate">
            <div className="trans-tips">{getLabel(518684, '您已进入翻译模式，点击高亮显示的页面文字即可进行翻译')}</div>
            <div className="trans-exit" onClick={this.exitTranslatepage}>
              {getLabel(518685, '退出翻译模式')}
            </div>
          </div>
        ) : null}
        {hideHeader == 'true' ? null : (
          <div className="e9theme-layout-header" style={translatepage == '1' ? { top: '30px' } : { top: '0px' }}>
            <E9Header ecId={`${(this && this.props && this.props.ecId) || ''}_E9Header@a94fye`} />
          </div>
        )}
        <div className="e9theme-layout-content" style={{ top: contenttop }}>
          <div id="themeLayoutMask" className="e9theme-layout-mask" />
          {hideAside == 'true' ? null : (
            <div className="e9theme-layout-aside">
              <E9LeftMenu ecId={`${(this && this.props && this.props.ecId) || ''}_E9LeftMenu@djnyzf`} />
            </div>
          )}
          <div className="e9theme-layout-main" style={hideHeader == 'true' && hideAside == 'true' ? { padding: 0 } : {}}>
            <div id="themeLayoutRoute" className="e9theme-layout-route">
              {this.props.children}
            </div>
            <div id="themeLayoutFrame" className="e9theme-layout-frame">
              <iframe id="mainFrame" name="mainFrame" src="about:blank" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  exitTranslatepage = () => {
    const { portalThemeStore } = this.props;
    portalThemeStore.setTranslatepage(0);
    // 左侧菜单高度更正
    const asdh = $('.e9aside-container').height() - $('.e9aside-container .wea-intro-step').height() + 30;
    $('.e9aside-container #menuScrollWrapper').css({ height: asdh });
  };
}

export default E9Theme;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/index.js